var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.$store.getters.count)?_c('LoginCode',{on:{"codeChange":_vm.codeChange}}):(!_vm.prereg)?_c('LoginNoPreRegistration',{attrs:{"code":_vm.code}}):_c('LoginWithPreRegistration',{attrs:{"code":_vm.code}})
}
var staticRenderFns = []

export { render, staticRenderFns }